import { Vector3 } from '@babylonjs/core';
import * as O from 'fp-ts/Option';
import { pipe } from 'fp-ts/lib/function';
import { iso } from 'newtype-ts';
import * as Event from '../event';
import { addModel, events, scene } from '../renderer';
import * as ShadowRoom from '../shadowRoom';
import * as Transform from '../transform';
const _ = iso();
// Gets a position for a product to be placed at, according to the complete bounding box and placement designation
const getProductPlacementPosition = (parentTransform, placement) => {
    const bb = parentTransform.getHierarchyBoundingVectors();
    const depth = bb.max.z - bb.min.z;
    const height = bb.max.y - bb.min.y;
    // constrain values within a range
    const yPosition = placement === 'Floor' || placement === 'WallAndFloor'
        ? 0.0
        : height / 2 < 0.1
            ? 0.1
            : height / 2 > 0.3
                ? 0.3
                : height / 2;
    const xPosition = 0.0;
    const zPosition = placement === 'OtherProduct' || placement === 'Floor'
        ? depth / 2 < 0.1
            ? 0.1
            : depth / 2 > 0.5
                ? 0.5
                : depth / 2
        : 0.0;
    return new Vector3(xPosition, yPosition, zPosition);
};
// Update position and visibility of shadow surfaces according to placement
const updateShadowSurfaces = (ground, wall, placement, backOfFurniture) => {
    pipe(ground, O.map(g => {
        if (placement === 'Floor' || placement === 'WallAndFloor') {
            g.setEnabled(true);
            g.position = new Vector3(0, 0, 10 + backOfFurniture);
        }
        else {
            g.setEnabled(false);
        }
    }));
    pipe(wall, O.map(w => {
        if (placement === 'Wall' || placement === 'WallAndFloor') {
            w.setEnabled(true);
            w.position = new Vector3(0, 10, backOfFurniture);
        }
        else {
            w.setEnabled(false);
        }
    }));
};
export const render = async (renderer, product) => {
    const _scene = scene(renderer);
    const oldRootTransform = Transform.findRootParticle(_scene.transformNodes);
    // possilby 'bake in' the idea of using a particle when creating a root particle transform to clean this up.
    if (oldRootTransform && oldRootTransform.id === product.id) {
        return { newTransform: oldRootTransform };
    }
    else if (oldRootTransform) {
        oldRootTransform.dispose(false);
    }
    Transform.disposeOtherTypes([Transform.Type.SINGLE_PARTICLE_TRANSFORM])(_scene.transformNodes);
    const rootTransform = Transform.createForRootParticle();
    rootTransform.setEnabled(false);
    rootTransform.id = product.id;
    try {
        await addModel(renderer, rootTransform, product.modelUrl);
    }
    catch (error) {
        events(renderer).emit(Event.Kind.OnError, {
            reason: `Model for product ${product.id} failed to load in Inspiration`,
        });
    }
    rootTransform.position = getProductPlacementPosition(rootTransform, product.placement);
    const back = rootTransform.getHierarchyBoundingVectors().min.z;
    updateShadowSurfaces(pipe(renderer, scene, ShadowRoom.ShadowFloor.get), pipe(renderer, scene, ShadowRoom.ShadowWall.get), product.placement, back);
    rootTransform.setEnabled(true);
    return { newTransform: rootTransform };
};
